<template>
  <div class="log-event-container">
    <!-- <div class="page-header">
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("logEvent") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
    </div> -->
    <h2 class="heading-text">Log Event</h2>
    <div class="mt-2 mb-4"><hr /></div>

    <v-card class="card2" style="margin-top: 1rem">
      <div class="d-flex align-center gap-2">
        <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="img" width="20" height="20">
        <p class="card-title">{{ $t('dateRange') }}</p>
      </div>

      <!-- <v-card-title class="d-flex align-center justify-space-between mb-2">
        <div class="d-flex align-center">
          <h3 class="text-h5 font-weight-bold text-primary">{{ $t("log_menagement") }}</h3>
        </div>
      </v-card-title> -->

      <v-row class="items-center mt-2">
        <!-- Start Date -->
        <v-col cols="12" sm="4">
          <div class="mb-1 d-flex align-center" style="gap: 2px">
            <label for="Start Date" class="text-sm font-medium text-gray-700">
              Start Date
            </label>
            <v-tooltip location="top" max-width="230px">
              <template v-slot:activator="{ props }">
                <img
                  v-bind="props"
                  src="@/assets/intent group toolip.svg"
                  alt="info"
                  width="18"
                  height="18"
                  style="cursor: pointer; margin-left: 4px;"
                />
              </template>
              <span>Select start date for filtering.</span>
            </v-tooltip>
          </div>
          <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
            <template #activator="{ props }">
              <v-text-field
                v-model="startDate"
                readonly
                variant="plain"
                v-bind="props"
                density="compact"
                color="grey"
                class="date-style"
              >
                <template #prepend-inner>
                  <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="startDate" @update:model-value="val => { startDate = formatDate(val); startDateFlag = false }" color="red"></v-date-picker>
          </v-menu>
        </v-col>

        <div class="date-divider">-</div>

        <!-- End Date -->
        <v-col cols="12" sm="4">
          <div class="mb-1 d-flex align-center" style="gap: 2px">
            <label for="End Date" class="text-sm font-medium text-gray-700">
              End Date
            </label>
            <v-tooltip location="top" max-width="230px">
              <template v-slot:activator="{ props }">
                <img
                  v-bind="props"
                  src="@/assets/intent group toolip.svg"
                  alt="info"
                  width="18"
                  height="18"
                  style="cursor: pointer; margin-left: 4px;"
                />
              </template>
              <span>Select end date for filtering.</span>
            </v-tooltip>
          </div>
          <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
            <template #activator="{ props }">
              <v-text-field
                v-model="endDate"
                readonly
                variant="plain"
                v-bind="props"
                density="compact"
                color="grey"
                class="date-style"
              >
                <template #prepend-inner>
                  <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="endDate" @update:model-value="val => { endDate = formatDate(val); endDateFlag = false }" color="red"></v-date-picker>
          </v-menu>
        </v-col>

        <!-- Search Button -->
        <v-col cols="12" sm="1">
          <div class="search-divider">
            <div class="mt-8">
              <button type="button" @click="Search" class="search-btn">
                <img src="@/assets/search.svg" alt="img" width="20" height="20" style="margin-top: 6px;">
              </button>
            </div>
            <div class="action-divider mt-2"></div>
          </div>
        </v-col>

        <!-- Advance Filters -->
        <v-col cols="12" sm="2">
          <div class="advance-filters">
            <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
            <span style="color: #C32E0E; font-size: 10px;">Advance Filters</span>
            <v-switch v-model="detailsExpanded" class="memory-switch" hide-details></v-switch>
          </div>
        </v-col>
      </v-row>

      <v-card v-if="detailsExpanded" class="advanced-filter-card mt-8 pa-4 mb-2">
        <div class="d-flex align-center gap-2">
          <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
          <p class="card-title">Filters Options</p>
          <!-- <p class="card-title">{{ $t("AdvancedFilters") }}</p> -->
        </div>
        <v-row class="mt-4">
          <v-col cols="12" sm="6" md="4">
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="API Name" class="text-sm font-medium text-gray-700">
                API Name
              </label>
              <v-tooltip location="top" max-width="320px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>Enter the identifier or name of the API responsible for initiating the logged action.</span>
              </v-tooltip>
            </div>
            <v-text-field
              v-model="apiNameQuery"
              variant="plain"
              density="comfortable"
              class="modern-input"
              placeholder="API Name"
              color="grey"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <!-- Create By -->
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Create By" class="text-sm font-medium text-gray-700">
                Create By
              </label>
              <v-tooltip location="top" max-width="280px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>Display the user account responsible for creating this entry.</span>
              </v-tooltip>
            </div>
            <v-text-field
              v-model="createByQuery"
              variant="plain"
              density="comfortable"
              class="modern-input"
              placeholder="Create By"
              color="grey"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <!-- Status Code -->
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Status Code" class="text-sm font-medium text-gray-700">
                Status Code
              </label>
              <v-tooltip location="top" max-width="300px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>The numeric code that reports the result of a network request or API operation.</span>
              </v-tooltip>
            </div>
            <v-select
              v-model="statusCodeQuery"
              :items="[
                { title: 'All', value: null },
                ...statusCode.map((item) => ({
                  title: item.name,
                  value: item.value,
                })),
              ]"
              variant="plain"
              density="comfortable"
              placeholder="Status Code"
              class="modern-input"
              color="grey"
            ></v-select>
          </v-col>
        </v-row>
        <v-row style="margin-top: -22px;">
          <v-col cols="12" sm="3" md="4">
            <!-- Status API -->
             <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Status API" class="text-sm font-medium text-gray-700">
                Status API
              </label>
              <v-tooltip location="top" max-width="320px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>Specify the API used to monitor the real-time operational status and uptime of the integrated service.</span>
              </v-tooltip>
            </div>
            <v-select
              v-model="statusApiQuery"
              :items="[
                { title: 'All', value: null },
                ...statusApi.map((item) => ({
                  title: item.name,
                  value: item.value,
                })),
              ]"
              variant="plain"
              density="comfortable"
              placeholder="Status API"
              class="modern-input"
              color="grey"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="3" md="4">
            <!-- Action -->
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Action" class="text-sm font-medium text-gray-700">
                Action
              </label>
              <v-tooltip location="top" max-width="350px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>Specify the type of operation that was performed or is to be performed.</span>
              </v-tooltip>
            </div>
            <v-select
              v-model="actionQuery"
              :items="[
                { title: 'All', value: null },
                ...actionList.map((item) => ({
                  title: item.name,
                  value: item.value,
                })),
                { title: 'Login', value: 'Login' },
              ]"
              variant="plain"
              density="comfortable"
              placeholder="Action"
              class="modern-input"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="3" md="2">
            <button type="button" class="download-btn">
              <span style="color: #ffffff; font-size: 14px;">Apply Filter</span>
            </button>
          </v-col>

          <v-col cols="12" sm="3" md="2">
            <button type="button" @click="clearFilters" class="clear-button">
              <img src="@/assets/charm_cross.svg" alt="img" width="22" height="22" />
              <span class="filter-by">{{ $t("ClearFilters") }}</span>
            </button>
          </v-col>
        </v-row>
      </v-card>
    </v-card>

    <v-card class="data-table-card mt-6">
      <v-card-text style="padding: 0">
        <v-card-text>
          <h2 style="font-weight: 600; color: #171717;">Log Results</h2>
        </v-card-text>
          <!-- <div class="d-flex align-center justify-space-between mb-4">
            <h4 class="section-title">
              <v-icon class="mr-2" color="primary" size="20"
                >mdi-text-box-search</v-icon
              >
              {{ $t('Result') }}
            </h4>
            <div class="d-flex justify-end">
              <v-btn
                color="grey-lighten-1"
                variant="text"
                class="mr-2"
                @click="clearFilters"
                :disabled="!hasActiveFilters"
              >
                {{ $t("ClearAll") }}
              </v-btn>
              <v-btn
                color="primary"
                variant="elevated"
                size="large"
                prepend-icon="mdi-magnify"
                rounded="xl"
                class="search-button"
                @click="Search"
              >
                <span class="button-text">{{ $t("search") }}</span>
              </v-btn>
            </div>
            <div>
              <v-btn 
                color="primary" 
                variant="tonal" 
                size="small" 
                class="mx-1" 
                prepend-icon="mdi-refresh"
                @click="refreshData"
              >
                Refresh
              </v-btn>
              <v-btn 
                color="success" 
                variant="tonal" 
                size="small" 
                prepend-icon="mdi-microsoft-excel" 
              >
                Export
              </v-btn>
            </div>
          </div> -->

          <v-data-table-server
            :headers="headers"
            :items="listLog.logDetail"
            :loading="loading"
            :items-length="listLog.allRow"
            :items-per-page="itemsPerPage"
            @update:options="options = $event"
            class="pa-4"
          >
          <template #no-data>
            <div class="d-flex justify-center align-center fixed" style="width: 100%">
              <span style="color: #646464; font-weight: 400;">No Data Available</span>
            </div>
          </template>

            <template v-slot:item.logType="{ item }">
              <div
                class="log-type-badge"
                :class="getLogTypeClass(item.columns.logType)"
              >
                <v-icon size="16" class="mr-1">{{
                  getLogTypeIcon(item.columns.logType)
                }}</v-icon>
                {{ item.columns.logType }}
              </div>
            </template>

            <template v-slot:item.timestamp="{ item }">
              <div class="timestamp-cell">
                <div class="date">{{ formatDate(item.columns.timestamp) }}</div>
                <div class="time">{{ formatTime(item.columns.timestamp) }}</div>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-center">
                <v-btn
                  icon
                  variant="text"
                  size="small"
                  color="primary"
                  @click="viewDetails(item)"
                  class="action-button mr-2"
                >
                  <v-icon>mdi-eye</v-icon>
                  <v-tooltip activator="parent" location="top"
                    >View Details</v-tooltip
                  >
                </v-btn>
              </div>
            </template>

            <template v-slot:bottom>
              <div class="table-bottom-group">
                <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                  <div>Total results {{ listLog.allRow }}</div>
    
                  <v-data-table-footer
                    :items="[
                      { text: '10', value: 10 },
                      { text: '25', value: 25 },
                      { text: '50', value: 50 },
                      { text: '100', value: 100 },
                      { text: 'All', value: -1 },
                    ]"
                    :page="options.page"
                    :length="Math.ceil(listLog.allRow / itemsPerPage)"
                  />
                </div>
              </div>
            </template>
          </v-data-table-server>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import { useDeferredTrue } from 'naive-ui/es/_utils';
import dateUtils from "../plugins/date-utils";
import moment from "moment";
export default {
  name: "LogEvent",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    detailsExpanded: false,
    isInitialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    type: "All",
    userChannel: "",
    sessionID: "",
    totalRow: 0,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    apiNameQuery: null,
    actionQuery: null,
    statusCodeQuery: null,
    statusApiQuery: null,
    createByQuery: null,
    listLog: {
      allRow: 0,
      logDetail: [
        {
          id: 0,
          apiName: "",
          action: "",
          statusCode: 0,
          statusApi: 0,
          exception: "",
          createBy: "",
          createDate: "",
        },
      ],
    },
    expandDateFilter: false, // ปิดโดย default
    expandFilters: false, // ปิดโดย default
    loading: false,
    sortBy: [],
    sortDesc: [],
    isSearch: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    actionList: [
      { name: "Create", value: "Create" },
      { name: "Delete", value: "Delete" },
      { name: "Update", value: "Update" },
    ],
    statusCode: [
      { name: "OK", value: 200 },
      { name: "Bad request", value: 400 },
      { name: "Internal server error", value: 500 },
    ],
    statusApi: [
      { name: "Succesful", value: 0 },
      { name: "Error", value: 1 },
      { name: "System error", value: 2 },
      { name: "Duplicate", value: 3 },
      { name: "Less", value: 4 },
      { name: "Exception", value: 5 },
    ],
    headers: [
      {
        title: "No.",
        align: "left",
        value: "id",
        sortable: false,
        width: "4%",
      },
      {
        title: "Api Name",
        align: "left",
        value: "apiName",
        sortable: true,
        width: "15%",
      },
      {
        title: "Action",
        align: "left",
        value: "action",
        sortable: true,
        width: "8%",
      },
      {
        title: "Status code",
        align: "left",
        value: "statusCode",
        sortable: true,
        width: "16%",
      },
      {
        title: "Status api",
        align: "left",
        value: "statusApi",
        sortable: true,
        width: "14%",
      },
      {
        title: "Message",
        align: "left",
        value: "exception",
        sortable: false,
        width: "15%",
      },
      {
        title: "Create by",
        align: "left",
        value: "createBy",
        sortable: true,
        width: "13%",
      },
      {
        title: "Create date",
        align: "left",
        value: "createDate",
        sortable: true,
        width: "20%",
      },
    ],
  }),
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.fetchLog();
      },
      deep: true,
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    var date = new Date();
    self.startDate = self.convertDateToString2(date);
    self.endDate = self.convertDateToString2(date);
    self.Search();
    this.isInitialized = true;
  },
  computed: {
    // เพิ่ม computed properties
    hasActiveFilters() {
      return (
        this.apiNameQuery ||
        this.createByQuery ||
        this.actionQuery ||
        this.statusCodeQuery ||
        this.statusApiQuery
      );
    },

    activeFilterCount() {
      let count = 0;
      if (this.apiNameQuery) count++;
      if (this.createByQuery) count++;
      if (this.actionQuery) count++;
      if (this.statusCodeQuery) count++;
      if (this.statusApiQuery) count++;
      return count;
    },
  },
  methods: {
    clearFilters() {
      this.apiNameQuery = null;
      this.createByQuery = null;
      this.actionQuery = null;
      this.statusCodeQuery = null;
      this.statusApiQuery = null;
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    formatNumber(value) {
      return value.toLocaleString();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.fetchLog();
    },
    fetchLog() {
      let self = this;
      const { page, itemsPerPage } = self.options;
      self.loading = true;
      self.sortBy =
        self.options.sortBy == undefined || self.options.sortBy.length == 0
          ? null
          : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc == undefined || self.options.sortDesc.length == 0
          ? null
          : self.options.sortDesc[0];
      var tempData = {
        startDate: self.startDate,
        stopDate: self.endDate,
        page: page,
        pageResult: itemsPerPage,
        apiNameQuery: self.apiNameQuery,
        actionQuery: self.actionQuery,
        statusCodeQuery: self.statusCodeQuery,
        statusApiQuery: self.statusApiQuery,
        createByQuery: self.createByQuery,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetEventLog(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listLog.logDetail = dataResponse.data.listData;
            if (self.listLog.logDetail.length != 0) {
              self.listLog.allRow = dataResponse.data.allRow;
              self.listLog.logDetail.forEach((log) => {
                log.createDate = self.Utc2Thai(log.createDate);
                log.statusCode = log.statusCode == 200 ? "OK" : log.statusCode;
                log.statusCode =
                  log.statusCode == 400 ? "Bad request" : log.statusCode;
                log.statusCode =
                  log.statusCode == 500
                    ? "Internal server error"
                    : log.statusCode;

                log.statusApi =
                  log.statusApi == 0 ? "Succesful" : log.statusApi;
                log.statusApi = log.statusApi == 1 ? "Error" : log.statusApi;
                log.statusApi =
                  log.statusApi == 2 ? "System error" : log.statusApi;
                log.statusApi =
                  log.statusApi == 3 ? "Duplicate" : log.statusApi;
                log.statusApi = log.statusApi == 4 ? "Less" : log.statusApi;
                log.statusApi =
                  log.statusApi == 5 ? "Exception" : log.statusApi;

                log.exception = log.exception == null ? "-" : log.exception;
              });
            }
            self.loading = false;
            self.isSearch = false;
          }
        },
        (errorResource) => {
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    Utc2Thai(Input) {
      var utc = new Date(Input);
      var local = new Date(utc.getTime() + 7 * 60 * 60 * 1000);
      var day = String(local.getDate()).padStart(2, "0");
      var month = String(local.getMonth() + 1).padStart(2, "0");
      var year = String(local.getFullYear()).slice();
      var hours = String(local.getHours()).padStart(2, "0");
      var minutes = String(local.getMinutes()).padStart(2, "0");
      // Format the date as dd/mm/yy hh:mm
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    getExceptionStyle(exception) {
      return exception == "-" ? { textAlign: "center" } : { textAlign: "left" }; //make exception placeholder center when it's was used
    },
    refreshData() {
      this.fetchLogs();
    },
    viewDetails(item) {
      this.selectedLog = item.columns;
      this.dialogDetail = true;
    },
  },
};
</script>
<style scoped>
.log-event-container {
  min-height: 100vh;
  padding: 16px;
}

.heading-text {
  color: #171717;
  font-weight: 600;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.card2 {
  border: 1px solid rgba(201, 201, 201, 1) !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}
.card-title {
  color: #171717;
  font-weight: 600;
  font-size: 14px;
}
.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}
.search-divider {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.date-divider {
  color: #c9c9c9;
  font-weight: 700;
  margin-top: 50px;
}
.search-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  height: 34px;
  width: 34px;
  border-radius: 18px;
  margin-left: -8px;
}
.action-divider {
  width: 2px;
  height: 60px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  transition: background-color 0.2s ease;
  margin-top: 6px;
}
.advance-filters {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
}
/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) { display: none !important; }
.v-input--density-default {
    --v-input-control-height: none;
}
.advanced-filter-card {
  background: rgba(239, 244, 255, 0.5) !important;
  border-radius: 16px;
  box-shadow: none;
}
.modern-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  margin-top: -5px;
}
.modern-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.modern-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.download-btn {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 120px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 6px;
  margin-top: 28px;
}
.download-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.clear-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 28px;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
}
.clear-button:hover {
  background: rgba(56, 89, 208, 0.1);
  border-radius: 10px;
}
.filter-by {
  color: #3859D0;
  font-size: 13px;
}
.data-table-card {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
}
/* table style */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.table-bottom-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.main-card {
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
  overflow: hidden;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
  display: flex;
  align-items: center;
}

.filter-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); */
}

.modern-input :deep(.v-field) {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
}

.modern-input :deep(.v-field:hover) {
  background-color: #f1f5f9 !important;
}
.modern-input :deep(.v-field__input) {
  padding: 8px 12px !important;
}

.search-button {
  background: linear-gradient(135deg, #4ade80 0%, #16a34a 100%) !important;
  box-shadow: 0 4px 14px rgba(22, 163, 74, 0.25) !important;
  transition: all 0.3s ease !important;
  min-width: 120px;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(22, 163, 74, 0.35) !important;
}

.button-text {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.results-section {
  padding: 0 16px 16px 16px;
}

/* .modern-table {
  border-radius: 12px;
  overflow: hidden;
}

.modern-table :deep(th) {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  font-size: 0.8125rem !important;
  letter-spacing: 0.5px !important;
  height: 48px !important;
}

.modern-table :deep(tr) {
  border-bottom: 1px solid #f1f5f9 !important;
  height: 52px !important;
}

.modern-table :deep(tr:hover) {
  background-color: rgba(241, 245, 249, 0.7) !important;
} */

.log-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 40px;
  font-size: 0.8125rem;
  font-weight: 500;
}

.log-type-badge.type-info {
  background-color: #e0f2fe;
  color: #0284c7;
}

.log-type-badge.type-warning {
  background-color: #fef3c7;
  color: #d97706;
}

.log-type-badge.type-error {
  background-color: #fee2e2;
  color: #dc2626;
}

.timestamp-cell {
  display: flex;
  flex-direction: column;
}

.timestamp-cell .date {
  font-weight: 500;
}

.timestamp-cell .time {
  font-size: 0.8125rem;
  color: #64748b;
}

.action-button {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.modern-dialog :deep(.v-card) {
  border-radius: 16px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(to right, #f8fafc, #f1f5f9);
}

.dialog-title {
  color: #1e293b;
  font-weight: 700;
  margin: 0;
}

.dialog-content {
  padding: 24px !important;
}

.log-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.detail-group {
  margin-bottom: 16px;
}

.detail-label {
  font-weight: 600;
  font-size: 0.8125rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.detail-value {
  color: #111827;
  font-size: 0.9375rem;
}

.message-container {
  margin-bottom: 16px;
}

.message-content {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  color: #1f2937;
  white-space: pre-wrap;
  word-break: break-word;
}

.session-id {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid #f1f5f9;
}

@media (max-width: 960px) {
  .search-button {
    width: 100%;
    margin-top: 16px;
  }
}

@media (max-width: 600px) {
  .log-event-container {
    padding: 8px;
  }

  .filter-section {
    padding: 12px;
  }

  .section-title {
    font-size: 1rem;
  }
}
</style>
